import Cookies from "js-cookie";

type ToolboxLoginInfo = {
    idpName: null | ZitadelIdpName;
    schoolUniqueKey: null | string;
}

const COOKIE_NAME = "toolboxLoginInfo";

export const LoginInfoManager = {
    get: (): ToolboxLoginInfo => {
        const _default: ToolboxLoginInfo = {
            idpName: null,
            schoolUniqueKey: null,
        };

        const data = Cookies.get(COOKIE_NAME);
        if (!data) return _default;

        try {
            return JSON.parse(data) as ToolboxLoginInfo;
        } catch (_error) {
            return _default;
        }
    },

    clear: (): void => {
        Cookies.remove(COOKIE_NAME);
    },

    isUsingAzureAsIdentityProvider: (): boolean => {
        return LoginInfoManager.get().idpName === "Azure";
    },
};
